var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronLeft15 = function SvgChevronLeft15(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 15 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m4.309 14.97 3.601 4.09 6.519 7.41c.516.588.694 1.289.483 2.087-.205.771-.679 1.242-1.369 1.4-.643.147-1.193-.088-1.654-.612q-2.292-2.6-4.582-5.2-3.323-3.78-6.646-7.563c-.88-1.001-.882-2.17-.001-3.172Q6.26 7.037 11.867.672c1.033-1.173 2.671-.748 3.055.793.19.768.03 1.455-.472 2.027L4.616 14.667c-.086.099-.185.183-.307.303",
    clipRule: "evenodd"
  })));
};
export default SvgChevronLeft15;